import React from 'react';
import { Loader2 } from 'lucide-react';

export function FullPageLoader({ label = 'Loading…' }) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-white/70" data-testid="full-page-loader">
      <Loader2 className="h-8 w-8 th-spin text-[#F6B24A]" />
      <p className="text-sm">{label}</p>
    </div>
  );
}

export function EmptyState({ title, body, action }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 p-8 text-center backdrop-blur-xl" data-testid="empty-state">
      <h3 className="font-display text-lg font-semibold" style={{ fontFamily: 'Space Grotesk' }}>{title}</h3>
      {body && <p className="mt-2 text-sm text-white/70">{body}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
